import React from "react";
import "./AdSlot.scss";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as Check } from "@assets/icons/check-circle.svg";
import { ReactComponent as Crown } from "@assets/icons/crown.svg";
import { Button, Collapse, Space } from "antd";
import { useUnit } from "contexts/UnitContext";

const AdSlot: React.FC = () => {
  const { units } = useUnit();

  return (
    <div className="AdSlot">
      <div className="title">
        Add Slot{" "}
        <div className="available-slot">
          Available ad slots{" "}
          <Button icon={<PlusOutlined />} iconPosition="end">
            0
          </Button>
        </div>
      </div>
      <div className="option-group">
        <Collapse
          collapsible="header"
          expandIconPosition="end"
          items={[
            {
              key: "1",
              label: (
                <>
                  <div className="collapse-header premium">
                    <span
                      className="label"
                      style={{ color: "var(--secondary-500)" }}
                    >
                      <Crown width={12} /> Premium
                    </span>
                    <span className="description">
                      2 additional free slots each month, 20% off extra slots
                    </span>
                  </div>
                  <div className="price">
                    49.98 {units.currency}
                    <span className="suffix"> / month</span>
                  </div>
                  <Button className="action-btn">Upgrade</Button>
                </>
              ),
              children: (
                <div className="collapse-content">
                  <span>
                    <Check width={20} /> 2 additional free slots each month
                  </span>
                  <span>
                    <Check width={20} /> 20% off extra slots ($8 / slot)
                  </span>
                  <span>
                    <Check width={20} /> Unlimited number of ads can be
                    purchased
                  </span>
                  <span>
                    <Check width={20} /> 1% cashback on total ad spend
                  </span>
                  <span>
                    <Check width={20} /> Performance reports
                  </span>
                </div>
              ),
            },
          ]}
        />
        <Collapse
          collapsible="header"
          expandIconPosition="end"
          items={[
            {
              key: "2",
              label: (
                <>
                  <div className="collapse-header premium">
                    <span className="label">Add slot package</span>
                    <span className="description">
                      Get 10 slots for a package
                    </span>
                  </div>
                  <div className="price">
                    $50.00
                    <span className="suffix"> ($5.00 / slot)</span>
                  </div>
                  <Button className="action-btn">Purchase</Button>
                </>
              ),
              children: (
                <div className="collapse-content">
                  <span>
                    <Check width={20} /> Get 10 slots for $50 ($5 per slot),
                    purchasable only once per month
                  </span>
                  <span>
                    <Check width={20} /> No Premium required
                  </span>
                  <span>
                    <Check width={20} /> Basic performance reports
                  </span>
                </div>
              ),
            },
          ]}
        />
        <Collapse
          collapsible="header"
          expandIconPosition="end"
          items={[
            {
              key: "3",
              label: (
                <>
                  <div className="collapse-header premium">
                    <span className="label">Add single slot</span>
                    <span className="description">
                      The number of slots will depend on your selection
                    </span>
                  </div>
                  <div className="price">
                    10.00 {units.currency}
                    <span className="suffix"> / slot</span>
                  </div>
                  <Button className="action-btn">Purchase</Button>
                </>
              ),
              children: (
                <div className="collapse-content">
                  <span>
                    <Check width={20} /> Freely set your ad slots, purchasable
                    only once per month
                  </span>
                  <span>
                    <Check width={20} /> Pay-as-you-go model
                  </span>
                  <span>
                    <Check width={20} /> Easily adjust flexibly
                  </span>
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default AdSlot;
